import _ from 'lodash'
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "../../../../global/cnr/reducers/reducerHelpers/dispatchProps"
import { convertHelpers } from "../../../../global/common/convert"
import { _deleteItemProps, dataFix } from "../../../../global/common/dataFix"
import { getCalStartDates } from "../../../../global/common/filtering"
import { createRefPath_event } from "../../../../global/firestoreData/appData/appRefPaths"
import { _sportLevels } from "../../helpers/league"
import { createSportsHelpers } from "./reducerHelpers/createSportsData"
import { getMatches_groupInfo } from './reducerHelpers/seasonSportsData'
import { sportsHelpers } from './reducerHelpers/sportsHelpers'
import { _sportsOriginTypes } from "./SportsReducer"
import { createFsDocKey_alt } from 'global/firestoreData/appData/fsAppData'
import { seasonalHelpers } from './reducerHelpers/seasonalHelpers'

const rts = {
  handleAmmend_ammendSeasonalItem: 'handleAmmend_ammendSeasonalItem',
  handleAmmend_districtTeams: 'handleAmmend_districtTeams',
  handleAmmend_levelTeams: 'handleAmmend_levelTeams',
  handleAmmend_seasonSectionDateGroup: 'handleAmmend_seasonSectionDateGroup',
  handleAmmend_sectionCrossovers: 'handleAmmend_sectionCrossovers',
  handleAmmend_selectedYearOrSeasonal: 'handleAmmend_selectedYearOrSeasonal',
  handleAmmend_sportsSeason_selected: 'handleAmmend_sportsSeason_selected',
  handleAmmend_teamsSport: 'handleAmmend_teamsSport',
  handleInit_sportsTeams: 'handleInit_sportsTeams',
  handleMedia_ammendSeasonalFromMedia: 'handleMedia_ammendSeasonalFromMedia',
  handleResults_seasonalData: 'handleResults_seasonalData',
  handleResults_sportsData: 'handleResults_sportsData',
  handleResults_sportSeasonals: 'handleResults_sportSeasonals',
  handleSeason_createFromPrevious: 'handleSeason_createFromPrevious',
  handleSelect_sectionLevel: 'handleSelect_sectionLevel',
  handleSelected_seasonDates: 'handleSelected_seasonDates',
  handleSet_crossover: 'handleSet_crossover',
  ...grts,
}

const _seasonalDataProps = ['details', 'sectionDates', 'crossSectionDates', 'playoffQualifyCounts', 'teams']
const orderedKeys = ['roundOf32', 'roundOf16', 'quarterFinals', 'semiFinals', 'finals'];
const _showLogs = false

const _baseSeasonSettings = (seasonalData) => {
  const { seasonals, seasonMatches } = seasonalData ?? {}
  return {
    seasonals: seasonals || {
      crossSectionDates: {},
      details: {},
      playoffQualifyCounts: {
        4: 4,
        5: 4,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
      },
      sectionCounts: {},
      sectionDates: {},
      teams: {},
      matches: {},
      homeAways: {},
    }
  }
}

const _init_state = {
  selectedItems: {
    year: null,
    seasonal: 'details'
  },
  sportsData_info: {
    districtTeams: {},
    sportSeasonals: {},
    teams_sport: {},
    sports: {},
  },
  sportsSeason_selected: { ..._baseSeasonSettings() }
}

export const seasonalUpdateSteps = {
  qualifyCount: 'qualifyCount',
  seasonSectionAlignment: 'seasonSectionAlignment',
  seasonDetails: 'seasonDetails',
  seasonSchedule: 'seasonSchedule',
  seasonSectionCount: 'seasonSectionCount',
  seasonSectionDates: 'seasonSectionDates',
  seasonSectionTeams: 'seasonSectionTeams',
  seasonCrossovers: 'seasonCrossovers',
  seasonTeams: 'seasonTeams',
  teams: 'teams',
  year: 'year',
}

const ammendSeasonalFluid = (sportsSeason_selected) => {

  const { seasonals, teams_seasonal } = sportsSeason_selected ?? {}
  const { teams } = teams_seasonal ?? {}
  const { details } = seasonals ?? {}
  const { seasonStartDate } = details ?? {}
  const { monthStartDates } = seasonStartDate ? getCalStartDates([seasonStartDate], 3) : {}

  const seasonals_fluid = {}

  if (seasonals_fluid) {
    seasonals_fluid.sportSeasonTeamCount = _.size(teams)
    seasonals_fluid.monthStartDates = monthStartDates
    seasonals_fluid.sectionTeamCounts = [6, 7]
    seasonals_fluid.sectionTeamCounts = groupTeamsByLevelsAndSections(teams)
    seasonals_fluid.teams = teams
  }
}

const getNewState = (existingState, newState, type) => {
  // Return the consistent state structure here
  const _newState = { ...existingState }

  _.forEach(newState, (ns, nsk) => {
    _newState[nsk] = ns
  })

  const { sportsSeason_selected, sportsSeason_media } = _newState

  ammendSeasonalFluid(sportsSeason_selected)

  if (sportsSeason_media) {
    ammendSeasonalFluid(sportsSeason_media)
  }

  _newState.sportsSeason_db = {
    crossSectionDates: sportsSeason_selected.crossSectionDates,
    seasonals: sportsSeason_selected.seasonals,
    teams: _newState.sportsSeason_selected.teams,
  }

  _newState._seasonalKey = _newState._seasonalId
  return _newState;
};

// const ammendSportsData = (state, key, value) => ({
//   ...state,
//   sportsData_info: {
//     ...(state.sportsData_info || {}),
//     [key]: value,
//   },
// })

const ammendSportsData = (state, value, key) => ({
  ...state,
  sportsData_info: {
    ...(state.sportsData_info || {}),
    ...(key ? { [key]: value } : value),
  },
})

const ammendSportSeasonal = (state, value, key) => ({
  ...state,
  sportsSeason_selected: {
    ...(state.sportsSeason_selected || {}),
    seasonals: {
      ...(state.sportsSeason_selected?.seasonals || {}),
      [key]: value,
    },
  },
})


export const createSportsSeasonReducer = (state, action) => {

  const { type, dispatch, levelItem, sectionItem, itemChecked } = action

  const {
    database_fns,
    sportsSeason_selected,
    grid_info,
    playoffInfo: _playoffInfo,
    mainDb,
  } = state

  const _sportsSeason_selected = sportsSeason_selected ? _.cloneDeep(sportsSeason_selected) : {}
  const { gridMatches } = grid_info ?? {}

  switch (type) {

    // when the year or seasonal changes
    case rts.handleAmmend_selectedYearOrSeasonal:
      const _selectedItems = _.cloneDeep(state.selectedItems)
      _selectedItems[action.dataType] = action.value
      return { ...state, selectedItems: _selectedItems }

    case rts.handleAmmend_sportsSeason_selected:
      const { seasonalData } = action
      if (!seasonalData) { return state }
      const { seasonals, teams_seasonal, matches_seasonal } = seasonalData ?? {}
      const { matches } = matches_seasonal ?? {}
      const { teams } = teams_seasonal ?? {}
      if (teams) {
        convertHelpers.createItemKeys(teams)
      }
      if (seasonals?.teams) {
        convertHelpers.createItemKeys(seasonals?.teams)
      }
      if (seasonals) {
        seasonals.teams = teams || seasonals?.teams
      }
      const _seasonalData = {
        matches: matches,
        seasonals: seasonals
      }
      return {
        ...state,
        sportsSeason_selected: _seasonalData ? { ..._seasonalData } : {},
        sportsSeason_selectedPdks: action?._parentDataKeys
      }


    case rts.handleResults_seasonalData:

      const { retData, fk } = action ?? {}
      const { teams: teams_seasonal2 } = retData ?? {}
      const _parentDataKeys = { ...state.parentDataKeys }

      if (fk) {
        _parentDataKeys['seasonals'] = fk
      }

      return {
        ...state,
        parentDataKeys: _parentDataKeys,
        seasonal_current: { ...state.seasonal_current, teams: teams_seasonal2 }
      }

    case rts.handleAmmend_districtTeams:
      if (_showLogs) {
        console.group('handleAmmend_districtTeams')
        console.log('districtTeams', action.data)
        console.groupEnd()
      }
      return ammendSportsData(state, action.data, 'districtTeams')

    case rts.handleInit_sportsTeams:
      if (_showLogs) {
        console.group('handleInit_sportsTeams')
        console.log('teams_sport', action.data)
        console.groupEnd()
      }
      return ammendSportsData(state, action.data, 'teams_sport')

    case rts.handleResults_sportSeasonals:
      const sss = {}
      _.forEach(action?.data, (ss, ssk) => {
        const { parentKeys } = ss ?? {}
        const { sportsYears } = parentKeys ?? {}
        sss[sportsYears] = ss
      })
      return ammendSportsData(state, sss, 'sportSeasonals')

    case rts.handleResults_sportsData:
      const { dataResult } = action
      return ammendSportsData(state, { ...dataResult })

    case rts.handleAmmend_ammendSeasonalItem:

      const zzz = ammendSportSeasonal(state, action.data, action.key)
      if (_showLogs) {
        console.group('handleAmmend_ammendSeasonalItem')
        console.log('handleAmmend_ammendSeasonalItem', action.key, action.data)
        console.log('zzz', zzz)
        console.groupEnd()
      }
      return zzz

    case rts.handleAmmend_teamsSport:
      const _sportSeasonTeams = _.cloneDeep(action.data)
      if (_showLogs) {
        console.group('handleAmmend_teamsSport')
        console.log('_sportSeasonTeams', _sportSeasonTeams)
        console.groupEnd()
      }
      const ttt = ammendSportSeasonal(state, _sportSeasonTeams, 'teams')
      return ttt

    case rts.handleAmmend_levelTeams:
      const { _sectionTeamCounts: stc, _seasonTeams: sts } = getSeasonTeams(action.data)
      if (_showLogs) {
        console.group('handleAmmend_levelTeams')
        console.log('teams', sts)
        console.groupEnd()
      }
      const bbb = ammendSportSeasonal(state, sts, 'teams')
      return bbb

    case rts.handleSelect_sectionLevel:
      return getNewState(state, { selectedSectionLevel: action.data }, type)

    case rts.handleMedia_ammendSeasonalFromMedia:

      const { mediaSeasonalData_current: msdc, matches_info } = action
      const { matchGroups } = msdc ?? {}
      const { matches: matches_combined } = matchGroups ?? {}

      convertHelpers.createItemKeys(matches_combined)

      const msds = { // sportsSeason_datas
        matchInfo_seasonal: {
          ...matchGroups
        },
        teams_seasonal: msdc?.teams,
        seasonals: {
          details: msdc?.details,
          sectionCounts: msdc?.sectionCounts,
          sectionDates: msdc?.sectionDates,
          teams: msdc?.teams
        },
        seasonals_fluid: {},
      }

      const _sdc2 = ammendSs_selected(state?.selectedItems?.year, msds)

      return getNewState(state, {
        sportsSeason_media: _sdc2,
      }, type)


    case rts.handleSelected_seasonDates:
      return getNewState(state, {
        sportsSeason_selected: createSportsHelpers.getCurrentSeasonInfo(state, action),
      }, type)

    case rts.handleAmmend_seasonSectionDateGroup:
      return getNewState(state, {
        sportsSeason_selected: createSportsHelpers.getCurrentSeasonInfo(state, action),
      }, type)

    case rts.handleSet_crossover:
      sportsSeason_selected.crossoverOn = !state?._sportsSeason_selected?.crossoverOn
      return getNewState(state, {
        sportsSeason_selected: sportsSeason_selected,
      }, type)

    case rts.handleAmmend_sectionCrossovers:
      return getNewState(state, {
        sportsSeason_selected: _sportsSeason_selected,
      }, type)

    case rts.handleSeason_createFromPrevious:
      const _ss = action.sportSeasonals?.[action.selectedYear]
      const { details, teams: teams_ss, sectionDates, homeAways } = _ss ?? {}
      const _sportsSeason_prev = {
        seasonals: {
          teams: Object.freeze(teams_ss),
          details,
          sectionDates,
          homeAways
        },
        sectionDates
      }
      return { ...state, sportSeasonals: action.sportSeasonals, sportsSeason_selected: _sportsSeason_prev }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterUpdate }, { gsMatchedRefreshed: false })


  }
}

export const createSportsSeasonHandlers = (dispatch) => {
  return {
    handleAmmend_ammendSeasonalItem: (key, data) => { dispatch({ type: rts.handleAmmend_ammendSeasonalItem, dispatch, key, data }) },
    handleAmmend_sportsSeason_selected: (seasonalData, _parentDataKeys) => { dispatch({ type: rts.handleAmmend_sportsSeason_selected, dispatch, seasonalData, _parentDataKeys }) },
    handleAmmend_districtTeams: (data) => { dispatch({ type: rts.handleAmmend_districtTeams, dispatch, data }) },
    handleAmmend_levelTeams: (data) => { dispatch({ type: rts.handleAmmend_levelTeams, dispatch, data }) },
    handleAmmend_seasonSectionDateGroup: (seasonDateProps) => { dispatch({ type: rts.handleAmmend_seasonSectionDateGroup, dispatch, seasonDateProps }) },
    handleAmmend_sectionCrossovers: (sectionCrossovers) => { dispatch({ type: rts.handleAmmend_sectionCrossovers, dispatch, sectionCrossovers }) },
    handleAmmend_selectedYearOrSeasonal: (dataType, value) => { dispatch({ type: rts.handleAmmend_selectedYearOrSeasonal, dispatch, dataType, value }) },
    handleAmmend_teamsSport: (data) => { dispatch({ type: rts.handleAmmend_teamsSport, dispatch, data }) },
    handleInit_sportsTeams: (data) => { dispatch({ type: rts.handleInit_sportsTeams, dispatch, data }) },
    handleMedia_ammendSeasonalFromMedia: (mediaSeasonalData_current, matches_info) => { dispatch({ type: rts.handleMedia_ammendSeasonalFromMedia, dispatch, mediaSeasonalData_current, matches_info }) },
    handleResults_seasonalData: (retData, fk) => { dispatch({ type: rts.handleResults_seasonalData, dispatch, retData, fk }) },
    handleResults_sportsData: (dataResult) => { dispatch({ type: rts.handleResults_sportsData, dispatch, dataResult }) },
    handleResults_sportSeasonals: (data) => { dispatch({ type: rts.handleResults_sportSeasonals, dispatch, data }) },
    handleSelect_sectionLevel: (data) => { dispatch({ type: rts.handleSelect_sectionLevel, dispatch, data }) },
    handleSelected_seasonDates: (seasonDateProps) => { dispatch({ type: rts.handleSelected_seasonDates, dispatch, seasonDateProps }) },
    handleSet_crossover: () => { dispatch({ type: rts.handleSet_crossover, dispatch }) },
    handleSeason_createFromPrevious: (sportSeasonals, selectedYear) => { dispatch({ type: rts.handleSeason_createFromPrevious, dispatch, sportSeasonals, selectedYear }) },
    ...responseHandlers(dispatch),
  }
}

export const createSportsSeasonInitialState = (init_state) => {
  return {
    ..._init_state,
    ...init_state,
  }
}

const getLevelTeams = (teams, sectionCounts) => {

  const groupedTeams = _.reduce(
    teams,
    (result, team, teamKey) => {
      const { levels, sections } = team;
      // Skip teams without levels
      if (!levels) return result;
      // Ensure the structure for levels and sections
      if (!result[levels]) result[levels] = {};
      if (!result[levels][sections]) result[levels][sections] = {};

      // Add the team
      result[levels][sections][teamKey] = team;

      return result;
    },
    {}
  );

  const section_counts = _.mapValues(groupedTeams, (sections) => _.size(sections));

  const _sectionCounts = {}
  const levelTeams = {}

  _.forEach(_sportLevels, (sl) => {
    _sectionCounts[sl] = section_counts[sl] ? section_counts[sl] : 0
    levelTeams[sl] = {}
  })

  _.forEach(groupedTeams, (gt, lk) => {
    _.forEach(gt, (st, sk) => {
      _.forEach(st, (t, tk) => {
        convertHelpers.createNestedObject(levelTeams, [lk, sk, tk])
        levelTeams[lk][sk][tk] = {
          name: t.name,
          _itemKey: t._itemKey
        }
      })
    })
  })

  return { sectionCounts: _sectionCounts, levelTeams }

}

const ammendHomeAways = (sportsSeason_selected, action) => {

  // sportsSeason_selected
  const { seasonals } = sportsSeason_selected ?? {}
  const { homeAways } = seasonals ?? {}

  if (action) {
    const _levelSectionKey = action.levelKey + '_' + action.sectionKey
    homeAways[_levelSectionKey] = action.homeAway
  } else {
    if (homeAways) {
      _.forEach(homeAways, (homeAway, haKey) => {
        homeAways[haKey] = !homeAway
      })
    }
  }
}

const getSeasonTeams = (levelTeams) => {

  const _sectionTeamCounts = [6, 7]
  const _seasonTeams = {}

  const addNumberIfNotExists = (arr, num) => {
    if (!_.includes(arr, num)) {
      arr.push(num);
    }
  };

  _.forEach(levelTeams, (level, levelKey) => {
    _.forEach(level, (sectionTeams, sectionKey) => {
      const _count = _.size(sectionTeams)
      addNumberIfNotExists(_sectionTeamCounts, _count)
      let _position = 0
      _.forEach(sectionTeams, (seasonTeam, seasonTeamKey) => {
        _seasonTeams[seasonTeamKey] = {
          name: seasonTeam.name,
          position: seasonTeam.position ? seasonTeam.position : _position,
          levels: levelKey,
          sections: sectionKey
        }
        _position++
      })
    })
  })

  _.forEach(_sectionTeamCounts, (stc, k) => {
    if (stc === 0) {
      delete _sectionTeamCounts[k]
    }
  })

  return { _sectionTeamCounts, _seasonTeams }
}

const groupTeamsByLevelsAndSections = (teams) => {
  // Group teams by level and then by section
  const groupedTeams = _.groupBy(teams, 'levels');
  const levels = _.mapValues(groupedTeams, (teamsInLevel) =>
    _.groupBy(teamsInLevel, 'sections')
  );

  const sectionCounts = [];

  // Iterate over levels and sections
  _.forEach(levels, (sections) => {
    _.forEach(sections, (teamsInSection) => {
      const numTeams = teamsInSection.length;
      // Add the number of teams to sectionCounts if it doesn't already exist
      if (!sectionCounts.includes(numTeams)) {
        sectionCounts.push(numTeams);
      }
    });
  });

  return sectionCounts.sort((a, b) => a - b);

};

// const checkDates = async (state) => {
//   const { pathViews, sports } = state;
//   const refPath = createRefPath_event(pathViews, ['_seasonals']);
//   const seasonals = await database_fns.get_data({ refPath });

//   for (const [sk, seasonal] of Object.entries(seasonals)) {
//     const { parentKeys, teams, sectionDates } = seasonal;
//     const { sports: sports_pk, sportsYears } = parentKeys ?? {};
//     console.log('sk', sk, seasonal)
//   }
// };

// const checkSeasonals = async (state) => {

//   const { pathViews, sports } = state;
//   const refPath = createRefPath_event(pathViews, ['_seasonals']);
//   const seasonals = await database_fns.get_data({ refPath });

//   for (const [sk, seasonal] of Object.entries(seasonals)) {
//     const { parentKeys } = seasonal;
//     const { sports: sports_pk, sportsYears } = parentKeys ?? {};

//     if (sports?.[sports_pk]) {
//       const sport = sports[sports_pk];
//       const { name } = sport ?? {};
//       const _abr = sportsHelpers.createSportAbr(name, sportsYears);
//       const _newKey = _abr + '_' + sk;
//       if (!sk.includes(_abr)) {
//         const refPath_new = createRefPath_event(pathViews, ['_seasonals', _newKey]);
//         const refPath_old = createRefPath_event(pathViews, ['_seasonals', sk]);
//         console.log('refPath_new', refPath_new, seasonal)
//         console.log('refPath_old', refPath_old)
//         // await database_fns.set_doc(refPath_new, seasonal);
//         // await database_fns.delete_doc(refPath_old);
//       } else {
//         // console.log('OK', sk, _abr, seasonal)
//       }
//       if (sk === 'MBKB_2025_MBB_2025_NK8bOCkbdjf7aMxK3qRg' || sk === 'WBKB_2025_WBB_2025_oWWuURfjlluwXAKNTUpQ') {
//         const _sks = sk.split('_')
//         const _nk = _abr + '_' + _sks[_sks.length - 1]
//         const refPath_new = createRefPath_event(pathViews, ['_seasonals', _nk]);
//         const refPath_old = createRefPath_event(pathViews, ['_seasonals', sk]);
//         console.log('refPath_new', refPath_new)
//         console.log('refPath_old', refPath_old)
//         await database_fns.set_doc(refPath_new, seasonal);
//         await database_fns.delete_doc(refPath_old);
//       } else {
//         // console.log('OK', sk, _abr, seasonal)
//       }
//     }
//   }
// };

// const checkSeasonals_teams = async (state) => {

//   const { pathViews, sports } = state;
//   const refPath = createRefPath_event(pathViews, ['_teams']);
//   const seasonals = await database_fns.get_data({ refPath });

//   for (const [sk, seasonal] of Object.entries(seasonals)) {
//     const { parentKeys } = seasonal;
//     const { sports: sports_pk, sportsYears } = parentKeys ?? {};

//     if (sports?.[sports_pk]) {
//       const sport = sports[sports_pk];
//       const { name } = sport ?? {};
//       const _abr = sportsHelpers.createSportAbr(name, sportsYears);
//       const _newKey = _abr + '_' + sk;
//       if (!sk.includes(_abr)) {
//         const refPath_new = createRefPath_event(pathViews, ['_teams', _newKey]);
//         const refPath_old = createRefPath_event(pathViews, ['_teams', sk]);
//         console.log('refPath_new', refPath_new, seasonal)
//         console.log('refPath_old', refPath_old)
//         await database_fns.set_doc(refPath_new, seasonal);
//         await database_fns.delete_doc(refPath_old);
//       } else {
//         console.log('OK', sk, _abr, seasonal)
//       }
//     }
//   }
// };

// const ammendSeasonalDetails = (seasonals) => {

//   const _playoffQualifyCounts = {
//     4: 4,
//     5: 4,
//     6: 4,
//     7: 4,
//     8: 4,
//     9: 4,
//   }

//   const { details } = seasonals ?? {}
//   _.forEach(details, (di, dik) => {
//     if (dik.startsWith('playoffTeamsPerSection')) {
//       const _dikc = dik.replace('playoffTeamsPerSection', '')
//       if (_dikc) {
//         _playoffQualifyCounts[_dikc] = di
//         delete details[dik]
//       }
//     }
//   })

//   seasonals.playoffQualifyCounts = _playoffQualifyCounts


// }

// const fixSeasonals = async (state) => {
//   const { pathViews } = state
//   const refPath = createRefPath_event(pathViews, ['_seasonals']);
//   const seasonals = await database_fns.get_data({ refPath });

//   const _seasonals = {}

//   for (const [sk, seasonal] of Object.entries(seasonals)) {
//     const { details, parentKeys, teams, sectionDates, scheduleDates, sectionCounts } = seasonal;
//     const lts = getLevelTeams(teams, sectionCounts)
//     _seasonals[sk] = {
//       parentKeys,
//       seasonals: {
//         details,
//         sectionCounts: sectionCounts ? sectionCounts : lts.levelCounts,
//         sectionDates: sectionDates ? sectionDates : scheduleDates,
//         teams
//       },
//     }

//     if (details) {
//       const _playoffQualifyCounts = {
//         4: 4,
//         5: 4,
//         6: 4,
//         7: 4,
//         8: 4,
//         9: 4,
//       }
//       _.forEach(details, (di, dik) => {
//         if (dik.startsWith('playoffTeamsPerSection')) {
//           const _dikc = dik.replace('playoffTeamsPerSection', '')
//           if (_dikc) {
//             _playoffQualifyCounts[_dikc] = di
//             delete details[dik]
//           }
//         }
//       })
//       _seasonals[sk].seasonals.playoffQualifyCounts = _playoffQualifyCounts
//     }
//   }

// }

const ammendSs_selected = (database_fns, mainDb, selectedSeason, sportsSeason_datas, matches_groupInfo) => {

  const ssdKeys = _.keys(sportsSeason_datas) // ['seasonals', 'playoffs', 'teams_seasonal', 'matches', 'playoffMatches', 'playoffMatches_backup', 'scores', 'playoffScores']
  const _seasonals_selected = adjustSeasonalCurrent(selectedSeason, sportsSeason_datas, matches_groupInfo)

  const {
    seasonals, // details, sectionDates, teams, playoffQualifyCounts
    seasonals_fluid, // matches_combined, crossoverMatches, levelTeams, matches_groupInfo ,seasonTeams, sectionCounts
  } = _seasonals_selected

  const { sportsSeason_selected } = _init_state
  const { seasonals: seasonals_init, seasonals_fluid: seasonals_fluid_init } = sportsSeason_selected

  const _seasonals = { ...seasonals_init, ...seasonals }
  const _seasonals_fluid = { ...seasonals_fluid_init, ...seasonals_fluid }

  const xxx = getSeasonalMatchesProps(_seasonals_selected)
  const { matches_combined, crossoverMatches } = createSportsHelpers.createTheSeasonMatches(database_fns, mainDb, xxx)

  _seasonals_fluid.matches_combined = matches_combined
  _seasonals_fluid.crossoverMatches = crossoverMatches

  const _sdc = {
    ..._init_state.sportsSeason_selected,
    seasonals: _seasonals,
    seasonals_fluid: _seasonals_fluid,
  }

  return _sdc

}

/**
 * 
 * @param {*} activeYear 
 * @param {*} sportsSeason_datas 
 * @param {*} matches_groupInfo 
 * @returns seasonals_current
 */
const adjustSeasonalCurrent = (activeYear, sportsSeason_datas, matches_groupInfo) => {

  const {
    matchInfo_seasonal, // matches, matches_playoffs, matches_combined, seasonMatches, seasonPlayoffMatches
    seasonals, //'details', 'teams', 'sectionDates', 'playoffQualifyCounts'
    teams_seasonal,
  } = sportsSeason_datas ?? {}


  const { teams, sectionCounts } = seasonals ?? {}

  const _teams = !_.isEmpty(teams_seasonal) ? teams_seasonal : teams

  const lts = getLevelTeams(_teams, sectionCounts)
  const { levelTeams } = lts // levelTeams, sectionCounts 

  let seasonals_fluid = {
    matches_groupInfo: matches_groupInfo,
    teams: _teams,
    ...lts
  }

  const homeAways = {}
  _.forEach(levelTeams, (level, levelKey) => {
    _.forEach(level, (section, sectionKey) => {
      const key = levelKey + '_' + sectionKey
      homeAways[key] = true
    })
  })

  seasonals_fluid.homeAways = homeAways
  seasonals.sectionCounts = lts.sectionCounts

  if (teams) {
    _.forEach(teams, (team) => {
      team._selected = true
    })
  }

  convertHelpers.createItemKeys(teams)

  // LOOK HERE
  const seasonals_current = {
    activeYear: activeYear,
    matchInfo_seasonal, // matches, matches_playoffs, matches_combined, seasonMatches, seasonPlayoffMatches
    seasonals,
    teams_seasonal,
    seasonals_fluid
  }

  return seasonals_current

}

const getSeasonalMatchesProps = (sportsSeason_selected) => {

  const { seasonals, matches_seasonal, seasonMatches, teams_seasonal } = sportsSeason_selected ?? {}
  const { crossSectionDates, sectionCrossovers, sectionDates, teams, homeAways } = seasonals ?? {}
  const { matches } = matches_seasonal ?? {}

  const _results = {
    // teams: state_obj?.teams_seasonal,
    crossSectionDates,
    homeAways,
    matches,
    sectionCrossovers,
    sectionDates,
    teams: teams,
  }

  const xxx = {
    gridMatches: null,
    gameScoringType: 'match',
    ..._results
  }

  return xxx

}

const combineMatches = (forPlayoffs, mediaMatches_grouped, matches_info, playoffInfo) => {

  const b = generateBracket(32)

  // existing matches
  const existingMatches = !forPlayoffs ? matches_info?.matches_groupInfo?.matches : matches_info?.matches_groupInfo?.matches_playoffs
  const existingMatches_levels = convertHelpers.groupBy_keys(existingMatches, 'levels')

  // mediaMatches
  const mediaMatches = !forPlayoffs ? mediaMatches_grouped?.matches : mediaMatches_grouped?.matches_playoffs
  const mediaMatches_levels = convertHelpers.groupBy_keys(mediaMatches, 'levels')

  // playoffTeams, groupedBy `levels`
  const { playoffLevelTeams } = playoffInfo ?? {}

  // create _itemKeys for each of the object
  convertHelpers.createItemKeys(mediaMatches)
  convertHelpers.createItemKeys(existingMatches)

  if (forPlayoffs) {

    // Group the existingMatches and mediaMatches by levels

    // Iterate over mediaMatches_levels
    _.forEach(mediaMatches_levels, (mediaMatches_level, levelKey) => {

      const existingMatches_level = existingMatches_levels?.[levelKey] ?? {};
      const playoffLevelTeams_level = playoffLevelTeams?.[levelKey] ?? {};

      // Group mediaMatches_level by `poolKey`
      const mediaMatches_pool = _.groupBy(mediaMatches_level, 'poolKey');
      // Create an ordered key structure
      const mediaMatches_pool_ordered = _.pick(mediaMatches_pool, orderedKeys);

      // Iterate over orderedMatches
      _.forEach(mediaMatches_pool_ordered, (matches_media, _poolKey) => {
        _.forEach(matches_media, (match_media) => {
          // find the match in existingMatches_level by pending.home and pending.away
          ammendPendingMatches(true, b, playoffLevelTeams_level, existingMatches_level, existingMatches, match_media)
        });
      });
    });
  }

  const _combinedMatches = {
    matchesFound: {}, // Stores matches found in existingMatches
    matchesNew: {} // Stores matches that are new (not found in existingMatches) 
  };

  // Loop through each match in mediaMatches
  _.forEach(mediaMatches, (mediaMatch) => {

    // Try to find a match in existingMatches based on home and away team names
    let existingMatch_found = getExistingMatch(existingMatches, mediaMatch)
    const existingMatch_found_alt = getExistingMatch_alt(existingMatches, mediaMatch)

    if (!existingMatch_found && existingMatch_found_alt) {
      existingMatch_found = existingMatch_found_alt
    }

    if (existingMatch_found) {
      // Clone the foundMatch to avoid modifying the original object
      const _existingMatch = _.cloneDeep(existingMatch_found);

      // Initialize _matchStatusTypes array to track match changes
      _existingMatch._matchStatusTypes = [];

      // Compare startDate to determine if the match date has changed
      if (_.get(mediaMatch, 'startDate') === _.get(existingMatch_found, 'startDate')) {
        _existingMatch._matchStatusTypes.push('exactMatch');
      } else {
        _existingMatch._matchStatusTypes.push('dateChanged');
      }

      // Merge the results object from mediaMatch into matchCopy
      if (mediaMatch.results) {
        _existingMatch.results = _.cloneDeep(mediaMatch.results);
        _existingMatch._matchStatusTypes.push('hasResults');
        // Compare results to check if scores have changed
        if (!_.isEqual(_.get(mediaMatch, 'results'), _.get(existingMatch_found, 'results'))) {
          _existingMatch._matchStatusTypes.push('scoresChanged');
        }
      }

      ammendMatchTeams(_existingMatch)

      // Store the updated match in matchesFound using _itemKey as the key 
      _combinedMatches.matchesFound[_existingMatch._itemKey] = _existingMatch;

    } else {

      _combinedMatches.matchesNew[mediaMatch._itemKey] = _.cloneDeep(mediaMatch);

      if (mediaMatch.poolKey !== 'consolation') {
        const existingMatches_levels = _.groupBy(existingMatches, 'levels');
        const playoffLevelTeams_level = playoffLevelTeams?.[mediaMatch.levels] ?? {};
        const existingMatches_level = existingMatches_levels?.[mediaMatch.levels] ?? {};
        ammendPendingMatches(true, b, playoffLevelTeams_level, existingMatches_level, existingMatches, mediaMatch)
      }
    }
  });

  const combinedMatches = {
    matchesFound_grouped: convertHelpers.groupBy_keys(_combinedMatches.matchesFound, '_matchCollectionKey'),
    matchesNew_grouped: convertHelpers.groupBy_keys(_combinedMatches.matchesNew, '_matchCollectionKey'),
    matchesFound_grouped_pool: {},
    matchesNew_grouped_pool: {}
  };

  const _nonMediaExisting = {}
  _.forEach(combinedMatches.matchesFound_grouped, (mediaMatches, levelKey) => {
    _nonMediaExisting[levelKey] = {}
    const existingMatches_level = existingMatches_levels[levelKey]
    _.forEach(existingMatches_level, (existingMatch, existingMatchKey) => {
      if (!mediaMatches[existingMatchKey]) {
        _nonMediaExisting[levelKey][existingMatchKey] = existingMatch
      }
    })
  })

  const _matchesFound_grouped = {}

  if (combinedMatches.matchesFound_grouped) {
    _.forEach(combinedMatches.matchesFound_grouped, (mg, mgk) => {
      const documentFieldName = 'playoffMatches'
      // const updateData = _.mapKeys(mg, (value, key) => `${documentFieldName}.${key}`);
      // console.log('updateData!!!', mgk, updateData)
      _matchesFound_grouped[mgk] = convertHelpers.groupBy_keys(mg, 'poolKey')
    })
  }

  const _matchesNew_grouped = {}

  if (combinedMatches.matchesNew_grouped) {
    _.forEach(combinedMatches.matchesNew_grouped, (mg, mgk) => {
      _matchesNew_grouped[mgk] = convertHelpers.groupBy_keys(mg, 'poolKey')
    })
  }

  combinedMatches.matchesFound_grouped_pool = _matchesFound_grouped
  combinedMatches.matchesNew_grouped_pool = _matchesNew_grouped

  console.log('combinedMatches', combinedMatches)

  return combinedMatches;
};

const ammendMatchTeams = (match) => {
  if (!match.teams) {
    match.teams = [];
  }
  if (match.away.id && !_.includes(match.teams, match.away.id)) {
    match.teams.push(match.away.id);
  }
  if (match.home.id && !_.includes(match.teams, match.home.id)) {
    match.teams.push(match.home.id);
  }
}

const getNextRound = (currentRound) => {
  const currentIndex = orderedKeys.indexOf(currentRound);
  if (currentIndex === -1) {
    return 'none'
  }
  // Return the next round if there is one
  return orderedKeys[currentIndex + 1] || null; // Returns null if no next round
};

const ammendPendingMatches = (ammendMatch, bracket, playoffLevelTeams_level, existingMatches_level, existingMatches, match_media) => {

  const { results, poolKey, home, away } = match_media ?? {};
  const { score } = results ?? {};

  const _poolKey = getNextRound(poolKey)

  if (!score) return {}; // Skip if no score

  // Determine the winning team
  const _winnerIsHome = score.home > score.away;
  const _winner = _winnerIsHome ? home : away;

  // Find the winning team in playoffLevelTeams_level
  const _winningTeam = _.find(playoffLevelTeams_level, { name: _winner.name })

  if (!_winningTeam) return; // Skip if no matching team found

  const seed = _winningTeam.seed
  const _seed = findFinalSeed(bracket, poolKey, seed)

  const get_pending = (pk) => {
    const _pendings = {
      // look in the pending object for the matching poolKey and originalSeed
      // the poolKey will be from the previous rounds
      lookingFor: {
        poolKey: pk,
        originalSeed: _seed,
      },
      match_home: _.find(existingMatches_level, (existingMatch) =>
        _.get(existingMatch, 'pending.home.poolKey') === pk &&
        _.get(existingMatch, 'pending.home.originalSeed') === _seed
      ),
      match_away: _.find(existingMatches_level, (existingMatch) =>
        _.get(existingMatch, 'pending.away.poolKey') === pk &&
        _.get(existingMatch, 'pending.away.originalSeed') === _seed
      ),
      matchesPool: _.filter(existingMatches_level, (existingMatch) =>
        _.get(existingMatch, 'pending.home.poolKey') === pk
      ),
      match_media: match_media,
      matchFound: getExistingMatch(existingMatches, match_media),
      winner: _winner,
      seed,
      _seed,
    }
    return _pendings
  }

  const pendings = get_pending(poolKey)

  if (ammendMatch) {
    if (pendings.match_away) {
      pendings.match_away.away = pendings.winner;
    } else if (pendings.match_home) {
      pendings.match_home.home = pendings.winner;
    } else {
      // console.log('No Match 2 for ', match_media)
      // console.log('matchesPool ', pendings.seed, pendings._seed, pendings.matchesPool)
    }
  }

  return pendings

}

const getExistingMatch = (existingMatches, mediaMatch) => _.find(existingMatches, (existingMatch) =>
  _.get(mediaMatch, 'home.name') === _.get(existingMatch, 'home.name') &&
  _.get(mediaMatch, 'away.name') === _.get(existingMatch, 'away.name')
);

const getExistingMatch_alt = (existingMatches, mediaMatch) => _.find(existingMatches, (existingMatch) =>
  _.get(mediaMatch, 'away.name') === _.get(existingMatch, 'home.name') &&
  _.get(mediaMatch, 'home.name') === _.get(existingMatch, 'away.name')
);

const getBracketName = (numTeams) => {
  switch (numTeams) {
    case 64:
    case 32:
    case 16:
      return 'roundOf' + numTeams;
    case 8:
      return 'quarterFinals';
    case 4:
      return 'semiFinals';
    case 2:
      return 'finals';
  }
}


const generateBracket = (numTeams) => {

  const bracket = {};

  // Generate the first round with correct seeding
  bracket[getBracketName(numTeams)] = Array.from({ length: numTeams / 2 }, (_, i) => ({
    matchNumber: i + 1,
    seeds: [i + 1, numTeams - i],
  }));

  while (numTeams > 1) {
    const currentRoundName = getBracketName(numTeams);
    const nextRoundName = getBracketName(numTeams / 2);

    bracket[nextRoundName] = Array.from({ length: numTeams / 4 }, (_, i) => {
      const prevMatch1 = bracket[currentRoundName][i];
      const prevMatch2 = bracket[currentRoundName][bracket[currentRoundName].length - 1 - i];

      return {
        matchNumber: i + 1,
        seeds: [Math.min(...prevMatch1.seeds), Math.min(...prevMatch2.seeds)], // Ensures correct serpentine pattern
      };
    });

    numTeams /= 2;
  }

  return bracket;
};

export const findFinalSeed = (bracket, roundName, seed) => {

  const roundNames = Object.keys(bracket);
  let currentSeed = seed;

  // Start at roundOf64 and progress through each round
  for (const round of roundNames) {
    const match = bracket[round].find(m => m.seeds.includes(currentSeed));

    if (!match) {
      throw new Error(`Seed ${currentSeed} not found in round ${round}`);
    }

    // Determine new seed based on who wins
    currentSeed = Math.min(...match.seeds); // The lower number seed advances

    // Stop if we reach the requested round
    if (round === roundName) {
      return currentSeed;
    }
  }

  throw new Error(`Round ${roundName} not found in bracket`);
};
